module.exports = __webpack_public_path__ + "img/diamond-ring.d7a1d742.svg";